    import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import './App.css';
// import HowAreYou from './components/HowAreYou';
// import WhoAreWe from './components/WhoAreWe';
// import WhereAreWe from './components/WhereAreWe';
// import HowWeAre from './components/HowWeAre';
// import Header from './components/Header';

import Museum from './museum/museum';

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/">
          <img alt='analytics' src="/.netlify/functions/analytics" referrerPolicy="origin-when-cross-origin" style={{ height: 1, width: 1, position: 'absolute' }} />
          <Museum />
        </Route>
        {/*
        <Route path="/home">
          <div className="app">
            <img alt='analytics' src="/.netlify/functions/analytics" referrerPolicy="origin-when-cross-origin" style={{ height: 1, width: 1, position: 'absolute' }} />
            <Header />
            <HowAreYou />
            <WhoAreWe />
            <HowWeAre />
            <WhereAreWe />
          </div>
        </Route> 
        */}
      </Switch>
    </Router>
  );
}

export default App;
